import { useState, useLayoutEffect, useRef } from 'react';

// Measures a container's content box size using ResizeObserver.
// Returns [ref, { width, height }].
export default function useContainerSize() {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (!ref.current) return;
    const element = ref.current;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const cr = entry.contentRect;
        setSize({ width: Math.round(cr.width), height: Math.round(cr.height) });
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, size];
}
